import { EventEmitter } from "modules/EventEmitter";
import { IStaticClassName, IInitializableWithStaticClassName } from "./Initializable";

export class Component<T extends IStaticClassName, DatasetKeys extends string = any> extends EventEmitter implements IInitializableWithStaticClassName<T> {
    /**
     * Typed dataset of the root element
     */
    protected readonly dataset: {
        [K in DatasetKeys]: string | undefined;
    };

    constructor(
        protected rootElement: HTMLElement,
        protected index: number,
    ) {
        super();
        this.dataset = (rootElement.dataset as {
            [K in DatasetKeys]: string | undefined;
        });
    }

    getRootElement(): HTMLElement {
        return this.rootElement;
    }

    destroy() { };
}